module.exports = __webpack_public_path__ + "img/find-white.6ac07f91.svg";